import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURLV1 } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import TextField from "@material-ui/core/TextField";
import ReactLoading from "react-loading";

export const CreateLineNotification = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Notification" }));
  const history = useHistory();
  const [start_date, setStart_date] = useState('');
  const [target, setTarget] = useState(null);
  const [listTarget, setListTarget] = useState([]);
  const [campaign, setCampaign] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const AlertError = (message) => {
    Swal.fire("Item key!", message, "error");
  };

  const getListTarget = async () => {
    const apiUrls = `${baseURLV1}/targetGroup?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setListTarget(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getStartData = async () => {
    await getListTarget()
  }

  useEffect(() => {
    getStartData()
  }, []);

  const onSubmit = async () => {
    var events = {
      group_condition_id: target == '' ? null : target,
    };

    let apiUrls = `${baseURLV1}/pushNotification/line`;
    let token = localStorage.getItem("Token");
    setIsLoading(true)
    axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        setIsLoading(false)
        Swal.fire(
          "Alert",
          "ทำรายการของเรียบร้อย",
          "success"
        );
      })
      .catch((err) => {
        setIsLoading(false)
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง Notification. !! " + err,
          "error"
        );
      });
  };

  return (
    <>
      <Card>
        <CardHeader title="Send Line Messages"></CardHeader>
        <CardBody>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "กลุ่มเป้าหมาย" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={target}
              onChange={(e) => {
                setTarget(e.target.value)
              }}
            >
              <option value={null} hidden>
                กรุณาเลือก
              </option>
              {listTarget &&
                listTarget.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.title_th}
                    </option>
                  );
                })}

            </select>
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/Notification">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {isLoading ? (
                <ReactLoading
                  type={"bars"}
                  color={"white"}
                  height={30}
                  width={30}
                />
              ) : 'Send'}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
